import {STATE_IDLE} from "../const";

export default {
    items: [],
    total: 0,
    lastError: null,
    status: STATE_IDLE,
    saving: false,
}
